import { ReactChild, ReactChildren, useState } from "react";
import Text, { TextType } from "components/Text";
import * as theme from "lib/styles/theme";
import ArrowIcon from "lib/svgs/Arrow";
import styled from "styled-components";
import { BrandColorPalette, TextAndShapesPalette } from "lib/styles/colors";
import { formatExpirationDate } from "core/credentials/helpers";
import { checkDateIsZeroValue } from "lib/checkDateIsZeroValue";
import ExpirationRow from "./ExpirationRow";

interface StyleProps {
  isExpanded: boolean;
}

const Container = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  margin-bottom: 24px;
  border-radius: 8px;
  border-width: 1px;
  ${({ isExpanded }) => `
    border-color: ${
  isExpanded ? BrandColorPalette.BRANDING : TextAndShapesPalette.PLACEHOLDER
};
  `}
`;

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;

// TODO - update for small screen responsiveness
const TextSectionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 240px;
`;

const ExpandButtonRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 120px;
`;
const NonExpandableSpacer = styled.div`
  width: 120px;
`;

interface Props {
  isOpen: boolean;
  isExpandable: boolean;
  header: string;
  expiration?: string | null;
  children: ReactChild | ReactChildren;
}

// this probably takes isOpen ,and generic child
export default function CredentialAccordianContainer({
  isOpen,
  isExpandable,
  header,
  expiration,
  children,
}: Props): JSX.Element {
  const [isExpanded, setIsExpaned] = useState<boolean>(isOpen ?? false);
  const formattedDate = formatExpirationDate(expiration);
  const expirationDate = !expiration
    ? null
    : checkDateIsZeroValue(expiration)
      ? null
      : new Date(expiration);
  const toggleOpenState = () => {
    if (isExpandable) {
      setIsExpaned(!isExpanded);
    }
  };

  return (
    <Container isExpanded={isExpanded}>
      <ContentContainer>
        <HeaderRow onClick={toggleOpenState}>
          <TextSectionWrapper>
            <Text type={TextType.TITLE_1}>{header}</Text>
          </TextSectionWrapper>
          <TextSectionWrapper>
            <Text style={{ margin: "0px" }} type={TextType.PARAGRAPH}>
              {formattedDate ? `Expires on ${formattedDate}` : "No Expiration"}
            </Text>
          </TextSectionWrapper>
          <TextSectionWrapper>
            <ExpirationRow expDate={expirationDate} />
          </TextSectionWrapper>
        </HeaderRow>
        {isExpandable ? (
          <ExpandButtonRow onClick={toggleOpenState}>
            {/*<Text
              fontColor={BrandColorPalette.BRANDING}
              style={{ marginRight: "6px" }}
              type={TextType.PARAGRAPH}
            >
              {isExpanded ? "Collapse" : "Expand"}
            </Text>*/}
            <ArrowIcon
              color={theme.colors.brand.Branding}
              rotation={isExpanded ? 90 : -90}
            />
          </ExpandButtonRow>
        ) : (
          <NonExpandableSpacer />
        )}
      </ContentContainer>
      {Boolean(isExpanded) && <>{children}</>}
    </Container>
  );
}

// function TopRow
